module.exports = __webpack_public_path__ + "img/84dcd60.jpg";